// extracted by mini-css-extract-plugin
module.exports = {"playerWrap":"VideoPlayerMobile_playerWrap_3hDs6","videoPlayer":"VideoPlayerMobile_videoPlayer_1IIBS"};